/* ==========================================================================
   BodenWerk – Versandkosten und Fortschritt zur kostenfreien Lieferung

   Boeden gehen per Spedition, die Fracht haengt am Gesamtgewicht. Ab 2000 €
   Warenwert entfaellt sie. Beides stand bisher nirgends auf der Seite und
   tauchte erst im Checkout auf.

   Dieses Modul rechnet beides aus den Daten in bw-versand-daten und schreibt
   es in das Geruest aus bw-versand-fortschritt. Produktseite und Warenkorb
   benutzen dieselbe Rechnung.

   Oeffentlich: window.bwVersand.aktualisieren(zustand)
     zustand = { warenwertCent, gewichtG, paketPreisCent, paketGewichtG }
     Die beiden Paketwerte sind optional und nur fuer den Hinweis gedacht,
     dass ein weiteres Paket die Lieferung kostenfrei macht.
   ========================================================================== */
(function () {
  var fmt = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var fmtKg = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

  function euro(cent) {
    return fmt.format(cent / 100) + ' €';
  }

  var daten = null;
  function ladeDaten() {
    if (daten !== null) return daten;
    var el = document.querySelector('[data-bw-versand-daten]');
    try {
      daten = el ? JSON.parse(el.textContent) : false;
    } catch (e) {
      daten = false;
    }
    return daten;
  }

  // Fracht in Cent, null wenn das Gewicht ueber der Staffel liegt.
  function fracht(gewichtG, d) {
    if (gewichtG <= 0) return 0;
    for (var i = 0; i < d.staffel.length; i++) {
      if (gewichtG <= d.staffel[i][0]) return d.staffel[i][1];
    }
    return null;
  }

  function el(wurzel, name) {
    return wurzel.querySelector('[data-bw-versand-' + name + ']');
  }

  function zeichne(wurzel, zustand) {
    var d = ladeDaten();
    if (!d) return;

    var basisCent = parseInt(wurzel.getAttribute('data-basis-cent'), 10) || 0;
    var basisGramm = parseInt(wurzel.getAttribute('data-basis-gramm'), 10) || 0;

    var warenwert = basisCent + (zustand.warenwertCent || 0);
    var gewicht = basisGramm + (zustand.gewichtG || 0);

    var label = el(wurzel, 'label');
    var betrag = el(wurzel, 'betrag');
    var bahn = el(wurzel, 'bahn');
    var fuellung = el(wurzel, 'fuellung');
    var fuss = el(wurzel, 'fuss');
    var tipp = el(wurzel, 'tipp');

    var anteil = Math.max(0, Math.min(1, warenwert / d.schwelleCent));
    var erreicht = warenwert >= d.schwelleCent;

    fuellung.style.transform = 'scaleX(' + anteil.toFixed(3) + ')';
    bahn.setAttribute('aria-valuenow', Math.round(anteil * 100));
    wurzel.classList.toggle('bw-versand--erreicht', erreicht);

    var f = fracht(gewicht, d);

    // Ueber der Staffel: der Checkout bietet keine Versandart an, der
    // Warenkorb fuehrt dort in die Angebotsanfrage.
    if (f === null) {
      wurzel.classList.add('bw-versand--grossmenge');
      label.textContent = 'Fracht wird individuell geplant';
      betrag.textContent = '';
      fuss.textContent =
        'Ihre Menge wiegt rund ' + fmtKg.format(gewicht / 1000) + ' kg und liegt über unserem Standardversand.';
      tipp.hidden = true;
      wurzel.hidden = false;
      return;
    }
    wurzel.classList.remove('bw-versand--grossmenge');

    if (erreicht) {
      label.textContent = 'Lieferung kostenfrei';
      betrag.textContent = '0,00 €';
      fuss.textContent = d.versandart + ' · ' + d.lieferzeit;
      tipp.hidden = true;
    } else {
      var fehlt = d.schwelleCent - warenwert;
      label.textContent = 'Noch ' + euro(fehlt) + ' bis zur kostenfreien Lieferung';
      betrag.textContent = euro(f);
      fuss.textContent = 'Lieferung derzeit ' + euro(f) + ' · ' + d.versandart + ' · ' + d.lieferzeit;

      // Ein weiteres Paket kippt die Schwelle und spart unterm Strich Geld.
      // Nur zeigen, wenn es tatsaechlich guenstiger wird.
      var pp = zustand.paketPreisCent || 0;
      var pg = zustand.paketGewichtG || 0;
      if (pp > 0 && warenwert + pp >= d.schwelleCent && f > pp) {
        var neuesGewicht = gewicht + pg;
        if (fracht(neuesGewicht, d) !== null) {
          tipp.textContent =
            'Ein weiteres Paket für ' +
            euro(pp) +
            ' macht die Lieferung kostenfrei. Unterm Strich zahlen Sie ' +
            euro(f - pp) +
            ' weniger.';
          tipp.hidden = false;
        } else {
          tipp.hidden = true;
        }
      } else {
        tipp.hidden = true;
      }
    }

    wurzel.hidden = false;
  }

  window.bwVersand = {
    aktualisieren: function (zustand) {
      var knoten = document.querySelectorAll('[data-bw-versand]:not([data-statisch])');
      for (var i = 0; i < knoten.length; i++) zeichne(knoten[i], zustand || {});
    },
    // Nach dem Austausch des Warenkorbs (bw-cart.js) neu zeichnen
    statischZeichnen: function () {
      initStatische();
    }
  };

  // Warenkorb und andere statische Stellen rechnen nur aus ihren Basiswerten.
  function initStatische() {
    var knoten = document.querySelectorAll('[data-bw-versand][data-statisch]');
    for (var i = 0; i < knoten.length; i++) zeichne(knoten[i], {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStatische);
  } else {
    initStatische();
  }
})();
